module.exports = __webpack_public_path__ + "img/cloud.4fbd6d8a.svg";